import React, { ReactNode } from 'react';
import WarningFilled from 'src/components/Icons/WarningFilled';
import Button from 'src/components/primitives/Button/Button';
import { getColorVar } from 'src/utils/theme/colorVars';
import { WithClassName } from 'src/utils/UtilityTypes';
import { cm } from 'src/utils/classNames';
import { Z_INDEX } from 'src/constants/zIndex';

interface Props extends WithClassName {
	title: string;
	message: ReactNode;
	action?: {
		onClick: () => void;
		label: string;
	};
}

export default function DisabledOverlayMessage({
	title,
	message,
	action,
	className,
}: Props) {
	return (
		<div
			className={cm(
				'absolute inset-0 grid place-items-center rounded-sm bg-overlay p-lg text-text-default',
				Z_INDEX.disabledOverlayMessage,
				className
			)}
		>
			<div className="flex flex-col justify-center gap-y-2xl">
				<div className="flex flex-col items-center gap-y-md text-center">
					<WarningFilled size={32} color={getColorVar('star-yellow')} />
					<span className="typo-h5">{title}</span>
					<div className="flex flex-col gap-y-xs typo-b4">{message}</div>
				</div>

				{action && (
					<Button size="md" onClick={action.onClick}>
						{action.label}
					</Button>
				)}
			</div>
		</div>
	);
}
